<template>
    <div class="support">
        <default :title="title" :items="items"  :with-accordion="true" :is-accordion-group="true" :wrap-content="true">
            <div v-if="load_appended_items" :slot="`slot-item-${items.length-1}`" class="contact-form" ref="contact-form">
                <div class="success-msg-con sent" v-if="sent_success">
                    {{ 'Your request was succesfully sent!' | translate }}
                </div>
                <div class="form-wrapper">
                    <form autocomplete="off" @submit.prevent="submit">
                        <div class="form-group contact-info-con">
                            <p class="info-text">{{ 'Didn\'t find what you were looking for?' | translate }}</p>
                            <p class="info-text">{{ 'Please send us an email and we will get back to you.' | translate }}</p>
                            <p  class="info-text email">
                                <a :href="`mailto:support@${host_name}`" class="email">
                                    <i class="fa fa-envelope"></i>{{ `support@${host_name}` }}
                                </a>
                            </p>
                            <p class="info-text">
                                <span class="toggler" @click="open_info = !open_info">
                                    <i :class="`fa fa-${!open_info ? 'plus': 'minus'}`"></i>{{ 'Or contact us using the form' | translate }}
                                </span>
                            </p>
                        </div>
                        <template v-if="open_info">
                            <div v-if="!showDesktop" class="form-group has-border-btm">
                                <p>{{ 'All fields are required' | translate }}</p>
                            </div>
                            <div class="form-group" v-if="!canSubmit">
                                <div class="error-msg-con">
                                    <i class="fa fa-exclamation-triangle"></i> {{ 'The fields marked in red are required. Please fill them to continue.' | translate }}
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-xs-12 col-sm-6">
                                    <label>{{ 'Username' | translate }}</label>
                                    <div class="input-wrapper">
                                        <input :class="`form-control darker-ph ${contact_formdata.name.error_msg ? 'invalid' : ''}`" type="text" :placeholder="'Will help us to identify you' | translate" v-model="contact_formdata.name.val" @input="validateInput(null, 'name')" @paste="validateInput($event, 'name')" :disabled="disable_name">
                                    </div>
                                    <div v-if="contact_formdata.name.error_msg" class="error-msg-con">
                                        <i class="fa fa-exclamation-triangle"></i> {{ contact_formdata.name.error_msg | translate }}
                                    </div>
                                </div>
                                <div class="form-group col-xs-12 col-sm-6">
                                    <label>{{ 'Subject' | translate }}</label>
                                    <div class="input-wrapper">
                                        <input :class="`form-control darker-ph ${contact_formdata.subject.error_msg ? 'invalid' : ''}`"  type="text" :placeholder="'Tell us how can we help you' | translate" v-model="contact_formdata.subject.val" @input="validateInput(null, 'subject')" @paste="validateInput($event, 'subject')">
                                    </div>
                                    <div v-if="contact_formdata.subject.error_msg" class="error-msg-con">
                                        <i class="fa fa-exclamation-triangle"></i> {{ contact_formdata.subject.error_msg | translate }}
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-xs-12 col-sm-6">
                                    <label>{{ 'Email' | translate }}</label>
                                    <div class="input-wrapper">
                                        <input :class="`form-control darker-ph ${contact_formdata.email.error_msg ? 'invalid' : ''}`"  type="text" :placeholder="'Connected to your account' | translate" v-model="contact_formdata.email.val" @input="validateInput(null, 'email')" @paste="validateInput($event, 'email')" :disabled="disable_email">
                                    </div>
                                    <div v-if="contact_formdata.email.error_msg" class="error-msg-con">
                                        <i class="fa fa-exclamation-triangle"></i> {{ contact_formdata.email.error_msg | translate }}
                                    </div>
                                </div>
                                <div v-show="!disable_email" class="form-group col-xs-12 col-sm-6">
                                    <label>{{ 'Repeat Email' | translate }}</label>
                                    <div class="input-wrapper">
                                        <input :class="`form-control darker-ph ${contact_formdata.email_repeat.error_msg ? 'invalid' : ''}`"  type="text" v-model="contact_formdata.email_repeat.val" @input="validateInput(null, 'email_repeat')"  @paste="validateInput($event, 'email_repeat')" :disabled="disable_email">
                                    </div>
                                    <div v-if="contact_formdata.email_repeat.error_msg" class="error-msg-con">
                                        <i class="fa fa-exclamation-triangle"></i> {{ contact_formdata.email_repeat.error_msg | translate  }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group message-wrap">
                                <label>{{ 'Message' | translate }}</label>
                                <div class="input-wrapper">
                                        <textarea :class="`form-control darker-ph desc ${contact_formdata.message.error_msg ? 'invalid' : ''}`"  type="text" :placeholder="'Write your message' | translate" v-model="contact_formdata.message.val" @input="validateInput(null, 'message')" @paste="validateInput($event, 'message')"></textarea>
                                </div>
                                <div v-if="contact_formdata.email_repeat.error_msg" class="error-msg-con with-textarea">
                                    <i class="fa fa-exclamation-triangle"></i> {{ contact_formdata.email_repeat.error_msg | translate  }}
                                </div>
                            </div>
                            <div class="form-group text-wrap">
                                <p v-if="showDesktop" class="info-text">{{ 'All fields are required' | translate }}</p>
                            </div>
                            <div class="form-group">
                                <div class="captcha-wrap">
                                    <recaptcha ref="recaptcha" :class="`recaptcha ${contact_formdata['g-recaptcha-response'].error_msg ? 'invalid' : ''}`"  @verify="verifyRecaptcha"></recaptcha>
                                </div>
                                <div v-if="contact_formdata['g-recaptcha-response'].error_msg"
                                class="error-msg-con">
                                    <i class="fa fa-exclamation-triangle"></i> {{ contact_formdata['g-recaptcha-response'].error_msg | translate }}
                                </div>
                            </div>
                            <div class="form-group btn-wrap">
                                <button class="btn btn-orange btn-send">{{ 'Send message' | translate }}</button>
                            </div>
                        </template>
                        <div class="address-image-con">
                            <img class="img-responsive" :src="image_address" :alt="`Business address ${site_name}`" v-cloak>
                        </div>
                    </form>
                </div>
            </div>
        </default>
    </div>
</template>

<script>
    import Default from '@theme-views/public/layouts/Default'
    import AccordionItem from '@theme-views/common/AccordionItem'
    import Recaptcha from '@views/common/Recaptcha'
    import Support from '@views/public/pages/Support/support'

    export default {
        mixins: [Support],
        components: {
            Default,
            AccordionItem,
            Recaptcha,
        },
        data() {
            return {
                load_appended_items: false
            }
        },
        computed: {
            title() {
                return this.showDesktop ? '' : 'Support'
            }
        },
        methods: {
            appendItem() {
                this.items.push({
                    question: this.$t('Other'),
                    use_slot_content: true, 
                    custom_container: true,
                })
                this.load_appended_items = true
            }
        }
    }
</script>

<style lang="scss">
    .support {
        .content-con {
            .address-image-con {
                max-width: 280px;
                padding: 0;
            }
            .form-group {
                margin-bottom: 8px;
                label {
                    margin-bottom: 8px;
                    color: #222;
                    display: flex;
                    font-family: 'Quicksand';
                    @include font-settings(normal, normal, normal, 1.31, bold);
                    font-size: 16px;
                }
                &.text-wrap {
                    margin-bottom: 16px;
                }
                &.message-wrap {
                    margin-bottom: 8px;
                }
                .form-control {
                    &:not([type="radio"]):not([type="checkbox"]) {
                        font-family: 'Nunito';
                        font-size: 14px;
                        @include font-settings(normal, normal, normal, 1.36, normal);
                        color: #222;
                        padding: 12px 16px;
                    }
                    &::placeholder {
                        font-family: 'Nunito';
                        font-size: 14px;
                        @include font-settings(normal, normal, normal, 1.36, normal);
                        color: #e5eced;
                        opacity: 0.3;
                    }
                }
                textarea {
                     &.form-control::placeholder {
                         color: #464a4c;
                     }
                }
                .ta-ftnote {
                    display: block;
                    position: absolute;
                    bottom: 10px;
                    left: 16px;
                    font-family: 'Nunito';
                    font-size: 12px;
                    @include font-settings(normal, normal, normal, normal, normal);
                    color: #7887a7;
                }
            }
            .text-wrap {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            p.info-text {
                margin: 0;
                a.email { 
                    color: #767678;
                    .fa {
                        color: #FF3B99;
                        margin-right: 5px;
                    }
                }
                &.email {
                    color: #273d52 !important;
                    text-decoration: underline;
                }
            }
            .contact-info-con {
                .info-text {
                    .toggler {
                        display: flex;
                        align-items: center;
                        .fa {
                            margin-right: 5px;
                            color: #FF3B99;
                        }
                    }
                }
            }
            .btn-wrap {
                margin-top: 50px;
                > .btn {
                    text-transform: none;
                    font-size: 16px;
                    max-width: 290px;
                    width: 100%;
                    padding: 14px 15px;
                }
            }
            .acc-content-con {
                &.custom-con {
                    padding: 24px 15px;
                    @media screen and (max-width: 1199px) {
                      padding: 15px;
                    }
                }
            }
            &.with-accordion {
              .con-wrapper {
                .accordion-content {
                  .accordion-item {
                    .acc-title-con {
                      font-weight: 700 !important;
                    }
                  }
                }
              }
            }
        }
    }
</style>
